import { RouteObject } from "react-router";
import { Lazy } from "@shared/components/ui/lazy";

const Agenda = Lazy(() => import("@shared/features/agenda/pages/agenda"), "Agenda");
const AgendaSettings = Lazy(() => import("@shared/features/agenda/pages/agenda-settings"), "AgendaSettings");

export interface AgendaRoutesProps {
  useOrganization?: boolean;
}

export const getAgendaRoutes = (
  props: AgendaRoutesProps = {}
): RouteObject[] => {
  const { useOrganization } = props;

  return [
    {
      path: "agenda",
      children: [
        { index: true, element: <Agenda useOrganization={useOrganization} /> },
        {
          path: "settings",
          element: <AgendaSettings useOrganization={useOrganization} />,
        },
      ],
    },
  ];
};
